var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-item-dropdown',{attrs:{"items":_vm.locations,"label":_vm.label,"disabled":_vm.disabled,"selected":_vm.selected,"can-remove":true},on:{"select":_vm.select,"remove":_vm.remove}})}
var staticRenderFns = []

export { render, staticRenderFns }